export const i18nValidation = {
  'invalidUrl': 'Bitte geben Sie eine gültige URL ein.',
  'invalidAppName': 'Bitte geben Sie den Namen der App ein.',
  'noImagesSelected': 'Bitte wählen Sie mindestens ein Bild aus.',
  'noImageSelected': 'Bitte wählen Sie ein Bild aus.',
  'enterText': 'Bitte geben Sie einen Text ein.',
  'textTooLong': 'Bitte beachten Sie die Zeichenbegrenzung.',
  'invalidVideoProvider': 'Bitte geben Sie einen gültigen Video Provider an.',
}
